import { Navigate, Route, Routes } from 'react-router'
import { useAuth } from './auth/AuthProvider'
import { Layout } from './components/Layout'
import { Loading } from './components/ui'
import { LoginPage } from './pages/LoginPage'
import { ChangePasswordPage } from './pages/ChangePasswordPage'
import { MyWorkPage } from './pages/MyWorkPage'
import { BoardPage } from './pages/BoardPage'
import { ProjectsPage } from './pages/ProjectsPage'
import { ProjectDetailPage } from './pages/ProjectDetailPage'
import { MeetingsPage } from './pages/MeetingsPage'
import { CompaniesPage } from './pages/CompaniesPage'
import { AdminPage } from './pages/AdminPage'
import { NotificationsPage } from './pages/NotificationsPage'
import { TaskLinkPage } from './pages/TaskLinkPage'
import { MeetingLinkPage } from './pages/MeetingLinkPage'

export function App() {
  const { user, loading } = useAuth()

  if (loading) {
    return (
      <div className="grid min-h-full place-items-center">
        <Loading label="Loading Atlas…" />
      </div>
    )
  }

  if (!user) {
    return (
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    )
  }

  // A temporary password gets you exactly one screen. The server enforces this
  // too — this is the matching UI, not the control itself.
  if (user.mustChangePassword) {
    return <ChangePasswordPage forced />
  }

  return (
    <Layout>
      <Routes>
        <Route path="/" element={<MyWorkPage />} />
        <Route path="/board" element={<BoardPage />} />
        <Route path="/projects" element={<ProjectsPage />} />
        <Route path="/projects/:projectId" element={<ProjectDetailPage />} />
        <Route path="/meetings" element={<MeetingsPage />} />
        <Route path="/companies" element={<CompaniesPage />} />
        <Route path="/notifications" element={<NotificationsPage />} />
        {/* Short paths because these get pasted into messages. */}
        <Route path="/t/:taskId" element={<TaskLinkPage />} />
        <Route path="/m/:meetingId" element={<MeetingLinkPage />} />
        <Route path="/password" element={<ChangePasswordPage forced={false} />} />
        <Route
          path="/admin"
          element={user.role === 'ADMIN' ? <AdminPage /> : <Navigate to="/" replace />}
        />
        {/* Signing in from /login lands here. */}
        <Route path="/login" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </Layout>
  )
}
